import React from 'react';
import Link from 'next/link';
import config from '../../config';

const { appHost } = config;

const LinkAnchor = (props) => {
    const { children, href, useAnchor, target, rel, /* options, */ testId } = props;

    if (!href) {
        return <a>{children}</a>;
    }

    if (useAnchor || href.startsWith('http')) {
        // external urls, like support page
        return <a href={href} target={target || `_blank`} rel={rel} data-testid={testId}>{children}</a>;
    }

    if (href.startsWith('app:')) {
        // links pointing to the utr app
        return <a href={href.replace('app:', appHost)} target={target || `_self`} rel={rel} data-testid={testId}>{children}</a>;
    }

    // internal routing within marketing app
    return (
        <Link href={href}>
            <a data-testid={testId} target={target || `_self`} rel={rel}>{children}</a>
        </Link>
    );
};

export default LinkAnchor;
